// Remove the parent product when child deleted
var deleteParent = '';

var oldFetch = fetch;
fetch = function(url, options) {
  	
	var promise = oldFetch(url, options);
  	
  	//CartJS.getCart();
/*
  	if(url == '/cart?view=mini-cart') {
        // SC AZ: remove child product if parent product removed
        $.each( CartJS.cart.items, function( index, item ) {
          console.log('ITEM', item);
          if(item.properties && item.properties._parent){

            var ok = false;
            $.each( CartJS.cart.items, function( index, i ) {
              if (i.id == item.properties._parent) {
                ok = true;
              }  
            });

            if(ok == false) {
              console.log('REMOVE CHILD');
              //CartJS.removeItemById(item.id);
            }
          }
        });            
    }
*/
  
  	if(url == '/cart/change.js') {
      //CartJS.getCart();
  	//if(url == '/cart?view=mini-cart' && deleteParent != '') {
      
      
      
		if(deleteParent != '') {      
	    	CartJS.removeItemById(deleteParent);
    		deleteParent = '';
        }
      
      //CartJS.getCart();
      //console.log(CartJS.cart.items);
  	}
	return promise;
}


$(function () {

	$('#mini-cart-items-list').on("click", "button", function (e) {
        
		//CartJS.getCart();
		//e.preventDefault();
		//e.stopImmediatePropagation();
      
      
		//Get item line number in the cart
        var miniCartItemLineNumber = $(this).data('remove-line');
          
        var itemRemove = CartJS.cart.items[miniCartItemLineNumber-1];
      
      	if(itemRemove.properties && itemRemove.properties._parent) {
        	$.each( CartJS.cart.items, function( index, item ) {
         		if(item.id == itemRemove.properties._parent){
            		deleteParent = item.id;
          		}
        	});
      	} else if(!itemRemove.properties || !itemRemove.properties._parent) {
          console.log('CCC', itemRemove);
        }
      
      	CartJS.getCart();
  });
  
});